/**
 * Shared labels and icons for simulation exam modules (Reading, Listening, etc.).
 * Used by result cards, review dialog, and charts to avoid duplicating display maps.
 */
import { BookOpen, Headphones, Mic, Pen, type LucideIcon } from 'lucide-react';
import type { SimulationModuleKey } from '@/lib/simulationResultsChartData';

export const SIMULATION_MODULE_ICONS: Record<SimulationModuleKey, LucideIcon> = {
  reading: BookOpen,
  writing: Pen,
  listening: Headphones,
  speaking: Mic,
};

export const SIMULATION_MODULE_SHORT_LABELS: Record<SimulationModuleKey, string> = {
  reading: 'Reading',
  writing: 'Writing',
  listening: 'Listening',
  speaking: 'Speaking',
};
